// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"a4c9d074","513":"05bd4db4","703":"fa0c7f5b","787":"21e03ae7"}[chunkId] + ".chunk.js";
};